import "../styles/Seperator.css";

export default function SectionSeparator({ text = "JAT TECHNOCRAFT GROUP" }) {
  return (
    <div className="section-separator">
      <span>{text}</span>
    </div>
  );
}